<template>
	<div id="Index_guardian_me" >
    <div class="Index_guardian_me_if" v-if="list_status">
       <ul class="infinite-list" style="overflow-y:auto;list-style-type:none;margin:0;padding:0px;" v-if="is_me">
        <li  v-for="guardian in list" :key="guardian.id" class="infinite-list-item guardian">
            <article>
              <img class="img-a" :src="guardian.avatar" />
              <img class="img-b" src="../assets/img/guard_u.png" alt="">
              <div class="guard-right">
                <div class="one">
                  <span class="guardian_name">{{guardian.user_nickname}}</span>
                  <span class="guardian-one-a guardian_red"><img src="../assets/img/13.png" /> {{guardian.age}} {{ $t('user.Age') }}</span>
                 <!-- <span class="guardian_one" v-if="guardian.age">{{guardian.age}}岁</span> -->
                  <span class="guardian-one-a guardian_blue" v-if="guardian.province">{{guardian.province}}</span>
                </div>
                <div class="two">
                  <div>{{guardian.title}}</div>
                  <span>{{guardian.endtime}} 到期</span>
                </div>
              </div>
            </article>
        </li>
      </ul>
      <ul class="infinite-list is_me_list" style="overflow-y:auto;list-style-type:none;margin:0;padding:0px;" v-else>
        <li  v-for="guardian in list" :key="guardian.id" class="infinite-list-item guardian guardian_t">
            <article>
              <img class="img-c" :src="guardian.avatar" />
              <img class="img-d" src="../assets/img/guard_u.png" alt="">
              <div class="guard-center">
                <div class="guardian_center_name">{{guardian.user_nickname}}</div>
                <div class="guardian_center_left">{{guardian.title}}</div>
                <div class="guardian_center_right">{{guardian.endtime}} 到期</div>
              </div>
            </article>
        </li>
      </ul>
    </div>
    <div style="width:100%;height:3em;line-height:3em;margin-top:2em;color:rgb(142, 140, 140);" v-else>
      <div v-if="is_me"> 暂无数据 </div>
      <div v-else>
         <ul class="infinite-list is_me_list" style="overflow-y:auto;list-style-type:none;margin:0;padding:0px;">
          <li class="infinite-list-item guardian guardian_t">
              <article>
                <img class="img-d" src="../assets/img/guard_u.png" alt="">
                <div class="guard-center">
                  <div class="guardian_center_name">暂无数据</div>
                </div>
              </article>
          </li>
        </ul>
      </div>
    </div>
		<div class="guardian_he" v-if="is_me">
			<el-button @click="guardian_btn">我要守护TA</el-button>
		</div>
	</div>
</template>

<script src="https://unpkg.com/element-ui/lib/index.js"></script>
 <script src="../../node_modules/vue/dist/vue.min.js"></script>
<script>
	//请求接口组件
  import '@/assets/css/style.css'
	import axios from 'axios'
	export default {
		name: 'Index_guardian_me',
		data(){
			 return {
				  list:[],
          is_me : false,
          list_status: false
        }
		},
		created: function() {
			this.convert();

		},
		methods: {
      convert: function() {
        var uid = this.$route.query.uid;
        var token = this.$route.query.token;
        var touid = this.$route.query.touid;
        this.is_me = uid == touid ? false : true ;

        document.title = this.is_me ? '守护我的' : '我守护的'

        console.log(touid)
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/guardian_api/vue_index",{ params:{ uid:uid,token:token,touid:touid,page:1}}).then(res => {
          console.log(res.data);
          this.list = res.data.data.list;
          this.list_status =res.data.data.list.length > 0 ? true :false
        })
      },
      guardian_btn() {
        var uid = this.$route.query.uid;
        var token = this.$route.query.token;
        var touid = this.$route.query.touid;

        this.$router.push({path:'/my_guardian',query:{uid:uid, token: token, touid:touid }});
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/guardian_me.vue